import React, { useEffect, useState } from "react";
import LeadsTable from "../Table/LeadsTable";
import LeadsFilterSearch from "./LeadsFilterSearch";

import { Alert, AlertTitle, Grid } from "@mui/material";
import LeadersSearchHeader from "./LeadersSearchHeader";
import {
  deleteLeadAction,
  dropFilterAction,
  dropLeadAction,
  dropLeadFindAction,
  dropLeadFindWithoutPaginationAction,
  leadFindAction,
} from "../../actions/leadActions/leadActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { findUserAction } from "../../actions/adminAuthAction";
import DownloadExcel from "../extraComponents/DownloadExcel";
import DownloadPdf from "../extraComponents/DownloadPdf";
import axios from "axios";
import Loader from "../LoaderComponent/Loader";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";

function LeadsDrop(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [data, setData] = useState([]);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagination] = useState(false)
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [filterPagination, setFilterPagination] = useState(false)
  const [currentFilterData, setCurrentFilterData] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // let { leadFindLoading, leadFindSuccess } = useSelector((state) => {
  //   return state.leadFind;
  // });

  const { dropLeadFindLoading, dropLeadFindSuccess } = useSelector((state) => state.dropLeadFind)

  const { dropLeadWithoutPaginationSuccess } = useSelector((state) => state.dropLeadWithoutPagination)  

  const { dropFilterSuccess } = useSelector((state) => state.dropFilter)
  
  let { leadAddSuccess } = useSelector((state) => {
    return state.leadAdd;
  });

  let { leadDeleteSuccess } = useSelector((state) => {
    return state.deleteLead;
  });

  let { leadOwnerSuccess } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  let { loginFindSuccess } = useSelector((state) => {
    return state.findUser;
  });
  
  useEffect(() => {
    dispatch(findUserAction());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(leadFindAction(25, 1, "dropLeads" ));
  // }, [dispatch, leadAddSuccess, leadDeleteSuccess, leadOwnerSuccess]);

  useEffect(() => {
    if (!searchPagination && !filterPagination || leadOwnerSuccess) {
    dispatch(dropLeadFindAction(pagiantionEntry, paginationPageNumber))
    dispatch(dropLeadFindWithoutPaginationAction())
    }
  }, [
    dispatch, 
    leadAddSuccess, 
    leadDeleteSuccess, 
    leadOwnerSuccess, 
    pagiantionEntry, 
    paginationPageNumber,
    searchPagination,
    filterPagination
  ])

  useEffect(() => {
    if (dropLeadFindSuccess || reset) {
      // setLeadData(dropLeadFindLoading?.allLeads?.filter((data) => data.status === "Drop"));
      setLeadData(dropLeadFindSuccess?.allLeads)
    }
  }, [dropLeadFindSuccess, reset]);

  useEffect(() => {
    if (dropFilterSuccess || reset) {
      setFilterPagination(true);
      setPaginationPageNumber(1);
      setLeadData(dropFilterSuccess?.allLeads)
    }
  }, [dropFilterSuccess, reset]);

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn])  

  useEffect(() => {
    setData(
      leadData
        ?.map((lead, index) => {
          if (lead.status !== "Application Started") {
            return {
              id: lead.id,
              sl: index + 1,
              name: lead?.firstName,
              email: lead.email,
              phone: lead.mobileNumber,
              whatsappNumber: lead.whatsappNumber,
              preferredCountry: lead.preferredCountryId,
              leadSource: lead.leadSource,
              leadOwner:
                loginFindSuccess &&
                loginFindSuccess.role !== null &&
                loginFindSuccess.role?.roleName === "branch manager"
                  ? lead?.user?.firstName
                  : lead.leadOwnerName,
              status: lead.status,
              priority: lead.priority ? lead.priority : "-",
              leadCity: lead.location,
              branchId: lead.branchId,
              leadBranch: lead?.branch_master?.branchName
                ? lead?.branch_master?.branchName
                : "-",
              leadCounsilor:
                loginFindSuccess?.role?.roleName !== "counsellor"
                  ? lead?.counsilorID
                    ? lead?.counsilorID
                    : "-"
                  : null,
              leadTeleCaller:
                loginFindSuccess?.role?.roleName !== "tele caller"
                  ? lead?.teleCallerId
                    ? lead?.teleCallerId
                    : "-"
                  : null,
              Reason:lead?.Reason
            };
          }
          return null;
        })
        .filter(Boolean)
    );
  }, [leadData]);

  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim()

      if (newSearchValue === "") {
        setSearchPagination(false);
        setLeadData(dropLeadFindSuccess?.allLeads);
        return;
      }

      setPaginationPageNumber(1)

    } catch (error) {
      console.error(error);
    }
  }

  const searchHandleChange = async (e) => {
    try {
      const newSearchValue = e.target.value.trim()

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(dropLeadFindAction(pagiantionEntry, paginationPageNumber));
        return;
      }

      setSearchValue(newSearchValue);
      setSearchPagination(true);
      setFilterPagination(false);

      fetchSearchResults(newSearchValue, paginationPageNumber);

    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNum) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/lead/searchdroplead?q=${value}&
          limit=${pagiantionEntry}&pagenumber=${pageNum}&id=${UserId}`, config)

      setSearchPaginationCount(data?.totalCount);
      setLeadData(data?.payload);
    } catch (error) {
      console.error(error);
    }
  };

  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);

  // material Table
  const columns = [
    {
      title: "Sl no",
      field: "sl",
    },
    {
      title: "Name",
      field: "name",
      // hidden: showNameColumn,
    },
    {
      title: "Email",
      field: "email",
      // hidden: showEmailColumn,
    },
    {
      title: "Phone     ",
      field: "phone",
      // hidden: showPhoneColumn,
    },

    {
      title: "What's App Number",
      field: "whatsappNumber",
      // hidden: showWhatsAppNumColumn,
    },
    {
      title: "Preferred Country",
      field: "preferredCountry",
      // hidden: showPrefferedColumn,
    },
    {
      title: "Lead Source",
      field: "leadSource",
      // hidden: showLeadSourceColumn,
    },
    {
      title:
        loginFindSuccess && loginFindSuccess?.role?.roleName == "branch manager"
          ? "Counsilor"
          : "Lead Owner",
      field: "leadOwner",
      // hidden: showLeadOwnerColumn,
    },
    {
      title: "Lead Branch",
      field: "leadBranch",
      // hidden: showLeadBranchColumn,
    },
    {
      title: "Status",
      field: "status",
      // hidden: showStatusColumn,
    },
    {
      title: "Priority",
      field: "priority",
      // hidden: showPriorityColumn,
    },
    {
      title: "Lead Place",
      field: "leadCity",
      // hidden: showLeadPlaceColumn,
    },
    {
      title: "Reason",
      field: "reason",
      // hidden: showReasonColumn,
    },
    {
      title:
        loginFindSuccess?.role == null ||
        loginFindSuccess?.isManager ||
        loginFindSuccess?.role?.roleName !== "tele caller"
          ? "TeleCaller"
          : null,
      field: "TeleCaller",
      // hidden: showTelecallerColumn,
    },
    {
      title:
        loginFindSuccess?.role == null ||
        loginFindSuccess?.isManager ||
        loginFindSuccess?.role?.roleName !== "counsellor"
          ? "Counsilor"
          : null,
      field: "Counsilor",
      // hidden: showCounsilorColumn,
    },
    {
      title: "",
      field: "action",
      filtering: false,
    },
  ];
  
  const excelDownloadClick = () => {
    DownloadExcel(columns, data, "Drop_Management");
  };

  const pdfDownloadClick = () => {    
    DownloadPdf(columns, data, "Drop_Management", "Drop Lead Details")
  }

  const toggleNameColumn = (status, columnName) => {    
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  const LeadFilterFunction = (filterData) => {
    try {
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      setFilterPagination(true);
      setPaginationPageNumber(1);
      dispatch(dropFilterAction(filterData, pagiantionEntry, 1));
    } catch (error) {
      console.error(error);
    }
  };

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(dropLeadFindAction(pagiantionEntry, 1));
  };

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(dropFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(dropLeadFindAction(value, 1));
    }
  };

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };

  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(dropFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(dropLeadFindAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (!hasPrivilege("Drop Leads") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }
  return (
    <>
      <LeadersSearchHeader
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        component="dead"
        subMenu="Drop Leads"
        column={columns}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      {/* <div style={{display:"flex",justifyContent:"space-evenly", width:"auto"}}> */}
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="lead"
            data={dropLeadWithoutPaginationSuccess?.allLeads}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
          {dropLeadFindLoading ? (
            <Loader />
          ) : data?.length === 0 ? (
            <TableNoItemComponent />
          ) : (
          <LeadsTable
            toggle={props.toggle}
            reset={reset}
            setIdsFunction={setIdsFunction}
            data={data}
            columns={columnVisibilityData?.length > 0 ? columnVisibilityData : columns}
            leadFindLoading={dropLeadFindLoading}
            selectBoxIdPassHandler={selectBoxIdPassHandler}
            isExistCounsilor={loginFindSuccess}
            component="leadDrop"
            pagiantionEntry={pagiantionEntry}
            paginationPageNumber={paginationPageNumber}
            subMenu="Drop Leads"
            mainMenu="drop"
            viewedColumn={viewedColumn}
            totalLeadCount={
              searchPagination ? searchPaginationCount : 
              filterPagination ? dropFilterSuccess?.totalCount :
              dropLeadFindSuccess?.totalCount
            }
            paginationDataFetching={paginationDataFetching}
          />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default LeadsDrop;
